import React from 'react';
import styled from 'styled-components';
import { colors, typography } from 'settings';

export interface SubtleTextProps extends React.HTMLAttributes<HTMLElement> {
    component?: React.ElementType<React.HTMLAttributes<HTMLElement>>;
}

const Text = styled.span`
    color: ${colors.fiftyFirstShade};

    small,
    small& {
        font-size: ${typography.typeScale.size2}px;
    }
`;

export default function SubtleText({ component: Component = 'span', ...other }: SubtleTextProps) {
    return <Text as={Component} {...other} />;
}
